import { useRef } from "react";
import { v4 as uuid } from "@lukeed/uuid";

const useId = (id?: string) => {
  const autoId = useRef(uuid()).current;
  return id ?? autoId;
};

export { useId };
